import type { ResearchSessionManifest } from "../../lib/api";
import { ArtifactRenderer } from "./ArtifactRenderer";

const DEDICATED = new Set(["README.md", "sources.json", "transcript.md", "viz.json", "session.md"]);

export function ArtifactRegistry({ manifest }: { manifest: ResearchSessionManifest }) {
  const artifacts = manifest.artifacts.filter((artifact) => !DEDICATED.has(artifact.kind));
  if (!artifacts.length) return null;
  return (
    <section className="mt-12 max-w-[68ch]">
      <h2 className="text-[15px] font-medium text-ink">Artifacts</h2>
      <div className="mt-3 grid gap-3">
        {artifacts.map((artifact) => (
          <article key={artifact.id} className="rounded-md border border-border bg-surface p-4">
            <div className="mb-2 flex items-center justify-between gap-3">
              <h3 className="text-[13px] font-medium text-ink">{artifact.title}</h3>
              {!artifact.stable && <span className="text-[11px] font-mono text-ink-faint">experimental</span>}
            </div>
            <ArtifactRenderer artifact={artifact} />
          </article>
        ))}
      </div>
    </section>
  );
}
